import React from 'react';
import Redux, { connect } from 'react-redux';

import { debounce } from 'lodash';

// import { ResponsiveAction, setIsMobile } from 'redux/modules/responsive';
import { DisplayAction, setIsMobile } from 'redux/modules/display';
import { IRootState } from 'redux/root_reducer';

import { BREAK_POINT } from 'constants/responsive';

interface ComponentProps {
    children: React.ReactNode;
}

interface StateProps {
    isMobile: boolean;
}

interface DispatchProps {
    setIsMobile: (isMobile: boolean) => Redux.Dispatch<DisplayAction>;
}

type CombinedProps = ComponentProps & DispatchProps & StateProps;

/**
 * Should wrap the entire application to keep track of whether we are in
 * mobile or desktop view. Component is connected to redux, and other components can
 * just pull the redux state.
 */
class Responsive extends React.Component<CombinedProps> {
    constructor(props: CombinedProps) {
        super(props);

        this.setMobile = this.setMobile.bind(this);
    }

    public componentDidMount() {
        this.setMobile();

        window.addEventListener('resize', debounce(this.setMobile, 500));
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', debounce(this.setMobile, 500));
    }

    public setMobile() {
        const isMobile = window.innerWidth < BREAK_POINT;

        if (this.props.isMobile !== isMobile) {
            this.setState({ isMobile }, () => this.props.setIsMobile(isMobile));
        }
    }

    public render() {
        return this.props.children;
    }
}

const mapStateToProps = ({ display }: IRootState) => ({
    isMobile: display.isMobile
});

const mapDispatchToProps = (dispatch: Redux.Dispatch<DisplayAction>) => ({
    setIsMobile: (isMobile: boolean) => dispatch(setIsMobile(isMobile))
});

export default connect<StateProps, DispatchProps, ComponentProps>(mapStateToProps, mapDispatchToProps)(Responsive);



// WEBPACK FOOTER //
// ./src/containers/global/responsive/Responsive.tsx